import { groupedTranslations } from '@mongez/localization';

groupedTranslations('wallet', {
  duplicateAccountError: {
    en: 'This account is blocked because it is duplicated',
    ar: 'تم حظر هذا الحساب لان هذا الحساب مكرر',
  },
});
